/**
 * Pauses the current async function in which it is called
 */
const sleep = (ms: number) => new Promise(r => setTimeout(r, ms));

export default sleep;
